import useFetch from '../../hooks/useFetch';
import { getSiteSettings } from '../../services/api';

import HeroSection from './HeroSection';
import TrustBar from './TrustBar';
import ServicesSection from './ServicesSection';
import CategoriesSection from './CategoriesSection';
import HowItWorksSection from './HowItWorksSection';
import WhyUsSection from './WhyUsSection';
import TestimonialsSection from './TestimonialsSection';
import FaqSection from './FaqSection';
import AboutSection from './AboutSection';
import CtaBannerSection from './CtaBannerSection';

function Landing() {
  // Site settings drives Hero, WhyUs stats, and CTA banner
  const { data: settings } = useFetch(() => getSiteSettings(), []);

  return (
    <main>
      <HeroSection settings={settings} />
      <TrustBarWrapper />
      <ServicesSection />
      <CategoriesSection />
      <HowItWorksSection />
      <WhyUsSection settings={settings} />
      <TestimonialsSection />
      <FaqSection />
      <AboutSection settings={settings} />
      <CtaBannerSection settings={settings} />
    </main>
  );
}

// Lazy wrapper so TrustBar fetches its own data
function TrustBarWrapper() {
  const { data } = useFetch(() => import('../../services/api').then((m) => m.getTrustItems()), []);
  return <TrustBar items={data} />;
}

export default Landing;
